import { ReactNode } from 'react'
import { twMerge } from 'tailwind-merge'
import { addPublicCustomClassNamePrefix } from 'modules/course/utils/add-class-prefix'
import { menuItemsConfig } from './menu-items-config'

export function MenuSkeleton(): ReactNode {
  return (
    <div
      className={twMerge(
        `flex animate-pulse items-center gap-5 xl:gap-5`,
        addPublicCustomClassNamePrefix('desktop-navbar-skeleton'),
      )}
    >
      {[...Array.from({ length: menuItemsConfig.length }).keys()].map(index => (
        <div key={index} className="h-5 w-20 rounded-sm bg-skeleton-primary" />
      ))}
    </div>
  )
}
